module.exports = __webpack_public_path__ + "media/_2_.100d41cc.mp3";